import PlatfomrsInstance from 'modules/platforms/repository';

export function getPlatformLegal(type, lang) {
  return PlatfomrsInstance.getPlatformLegal(type, lang);
}
